/**
 *
 * NumberBadge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import Badge from '..';

const StyledBadge = styled(Badge)`
  && {
    border-radius: ${({ theme }) => theme.borderRadius.primary};
  }
`;

function NumberBadge(props) {
  return <StyledBadge size="xs" variant="contained" {...props} />;
}

export default memo(NumberBadge);
